import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { en } from "./en";
import { gr } from "./gr";

const DICT = { en, gr };
const I18nContext = createContext(null);

function resolvePath(obj, path) {
  return path.split(".").reduce((o, k) => (o == null ? undefined : o[k]), obj);
}

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ithaca_lang") || "en");

  useEffect(() => {
    localStorage.setItem("ithaca_lang", lang);
    document.documentElement.lang = lang === "gr" ? "el" : "en";
  }, [lang]);

  const t = useCallback((path, vars) => {
    let val = resolvePath(DICT[lang], path);
    if (val === undefined) val = resolvePath(DICT.en, path); // fallback
    if (typeof val === "string" && vars) {
      Object.keys(vars).forEach((k) => { val = val.replaceAll(`{${k}}`, vars[k]); });
    }
    return val;
  }, [lang]);

  return (
    <I18nContext.Provider value={{ lang, setLang, t }}>{children}</I18nContext.Provider>
  );
}

export function useI18n() {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within I18nProvider");
  return ctx;
}
